import { WeekDay } from "../../../../types/generic.types";
import { SlotsMap } from "../types";

export const initialSlots: any = [
  [WeekDay.saturday, new Set()],
  [WeekDay.sunday, new Set()],
  [WeekDay.monday, new Set()],
  [WeekDay.tuesday, new Set()],
  [WeekDay.wednesday, new Set()],
  [WeekDay.thursday, new Set()],
  [WeekDay.friday, new Set()],
];

export const coachMinSlotTime: { id: number; name: string }[] = [
  { id: 15 * 60, name: "15 minutes" },
  { id: 30 * 60, name: "30 minutes" },
  { id: 45 * 60, name: "45 minutes" },
  { id: 60 * 60, name: "60 minutes" },
  { id: 75 * 60, name: "75 minutes" },
  { id: 90 * 60, name: "90 minutes" },
  { id: 105 * 60, name: "105 minutes" },
  { id: 120 * 60, name: "120 minutes" },
  { id: 135 * 60, name: "135 minutes" },
  { id: 150 * 60, name: "150 minutes" },
  { id: 165 * 60, name: "165 minutes" },
  { id: 180 * 60, name: "180 minutes" },
];

export const getDayName = (date: Date, lowerCased = true) => {
  const daysNamesArray = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  return (lowerCased ? daysNamesArray[date.getDay()].toLowerCase() : daysNamesArray[date.getDay()]) as WeekDay;
};

export const disableSubmitBtn = (slots: SlotsMap): boolean => {
  for (const entry of slots) {
    if (entry[1].size > 0) return false;
  }
  return true;
};
